import React, { useRef, useState, useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { useParams, useHistory } from "react-router-dom";
import { ValidatorForm } from "react-form-validator-core";
import MultiSelectValidator from "../components/MultiSelectValidator";
import TextValidator from '../components/TextValidator';
import Loader from "../components/Loader";
import Spinner from "../components/Spinner";
import Swal from "sweetalert2";
// Move this OUTSIDE the function component to prevent re-registration
ValidatorForm.addValidationRule("isItemSelected", (value) => {
  return Array.isArray(value) && value.length > 0;
});

const AdminUserEdit = () => {
  const { idUser } = useParams();
  const history = useHistory();
  const { getAccessTokenSilently } = useAuth0();
  const serverUrl = process.env.REACT_APP_SERVER_URL;
  const [isLoaded, setIsLoaded] = useState(false);
  const [isRunning, setIsRunning] = useState(false);

  //User Data
  const [allCompanies, setAllCompanies] = useState([]);
  const [userEmail, setUserEmail] = useState("");
  const [isCompanyUser, setIsCompanyUser] = useState(false);

  const [selectedCompanies, setSelectedCompanies] = useState([]);

  const handleCompanyChange = (selectedList) => {
    // MUST update state for validation to trigger via props
    setSelectedCompanies([...selectedList]);
  };

  useEffect(() => {
    async function getUser() {
      const token = await getAccessTokenSilently();
      localStorage.setItem("AcccessToken", token);

      const response = await fetch(`${serverUrl}/api/admin/user/` + idUser, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      const userDetails = await response.json();
      setUser(userDetails);
      // Preselect user’s companies:
      const initialSelected = userDetails.userCompanies.map((c) => ({
        idCompany: c.idCompany,
        companyName: c.companyName,
      }));
      setSelectedCompanies(initialSelected);

      setIsLoaded(true);
      setIsRunning(false);
      //Fetch user, userComapnies, Companies
      if (userDetails.company == 1) {
        await getCompanies();
      }
    }

    if (idUser) {
      getUser();
    } else {
      setIsLoaded(true);
      setIsRunning(false);
    }
  }, []);

  async function getCompanies() {
    const token = await getAccessTokenSilently();
    localStorage.setItem("AcccessToken", token);

    const response = await fetch(`${serverUrl}/api/admin/companies`, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const allCompanies = await response.json();
    setAllCompanies(allCompanies);
  }

  function setUser(user) {
    setUserEmail(user.email);
    setIsCompanyUser(user.company == 1);
  }


  //For react handling
  const handleSubmit = async (event) => {
    console.log("Form Submitted Successfully!", selectedCompanies);
    // Add your API call here

    swalWithBootstrapButtons
      .fire({
        title: "Bist Du sicher, dass Du speichern möchtest?",
        text: "",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Ja, speichern!",
        cancelButtonText: "Nein, abbrechen!",
        //reverseButtons: true
      })
      .then((result) => {
        if (result.isConfirmed) {
          Save(event);
        }
      });
  };

  const backToAllProducts = () => {
    try {
      history.push("/admin");
    } catch (error) {
      swalWithBootstrapButtons.fire({
        title: "Oops...",
        text: error.message,
        icon: "error",
      });
    }
  };

  const swalWithBootstrapButtons = Swal.mixin({
    customClass: {
      confirmButton: "btn btn-outline-warning",
      cancelButton: "btn btn-outline-warning",
    },
    buttonsStyling: false,
  });

  const Save = async (event) => {
    try {
      event.preventDefault();

      const accessToken = await getAccessTokenSilently();
      localStorage.setItem("AcccessToken", accessToken);

      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append("Authorization", `Bearer ${accessToken}`);

      //Add character validations on each property
      const userDetails = JSON.stringify({
        userCompanies: selectedCompanies,
      });

      const requestOptions = {
        headers: myHeaders,
        body: userDetails,
        redirect: "follow",
      };
      let url;
      //edit
      requestOptions.method = "PUT";
      url = `${serverUrl}/api/admin/user/` + idUser;

      let response = await fetch(url, requestOptions);
      let result = await response.json();

      if (result.isSuccessful) {
        swalWithBootstrapButtons.fire({
          title: "Gespeichert!",
          text: "",
          icon: "success",
        });
        backToAllProducts(); //Go back all products page.
      } else {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: result.message,
          //footer: '<a href="#">Why do I have this issue?</a>'
        });
      }
    } catch (err) {
      // catches errors both in fetch and response.json
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: err,
        //footer: '<a href="#">Why do I have this issue?</a>'
      });
    }
  };

  return (
    <React.Fragment>
      <section className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h1 className="m-0">{"User hinzufügen"}</h1>
            </div>
            {/* <div className="col-sm-6">
                            <ol className="breadcrumb float-sm-right">
                                <li className="breadcrumb-item"><a href="#">{"Startseite"}</a></li>
                                <li className="breadcrumb-item active">{idUser?.toString().trim() == "Titel" ? "Produkt hinzufügen" : "Produkt bearbeiten"}</li>
                            </ol>
                        </div> */}
          </div>
        </div>
      </section>

      <section className="content">
        <div className="card card-solid">
          <Spinner isRunning={isRunning} />
          {!isLoaded ? (
            <div className="text-center">
              <Loader />
            </div>
          ) : (
            <div className="container-fluid">
              {idUser && isCompanyUser && (
                <div className="alert alert-danger">
                  Double check all the information before updating as it's
                  updating user's data.
                </div>
              )}
              {!isCompanyUser && (
                <div className="alert alert-danger">
                  This user is not a company user.
                </div>
              )}

              {isCompanyUser && (
                <ValidatorForm onSubmit={handleSubmit}>
                  <div className="box-body">
                    <div
                      className="alert alert-success"
                      id="successMessage"
                      style={{ display: "none" }}
                    ></div>
                    <div
                      className="alert alert-danger"
                      id="errorMessage"
                      style={{ display: "none" }}
                    ></div>
                    <div className="form-group">
                      <div className="row">
                        <div className="col-md-12">
                          <TextValidator
                            disabled={true} // Dropdown deaktiviert
                            name="userEmail"
                            value={userEmail ? userEmail : ""}
                            isRequired={true}
                            label={"User Email"}
                          />
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-12">
                          <MultiSelectValidator
                            name="userCompanies" // <--- KEY FIX: Name must be here!
                            label={"User Companies *"}
                            displayValue="companyName" // Specific to your company object
                            allOptions={allCompanies}
                            value={selectedCompanies} // Add this!
                            selectedOptions={selectedCompanies}
                            onChange={handleCompanyChange}
                            validators={["isItemSelected"]}
                            errorMessages={[
                              "At least one company must be selected",
                            ]}
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="box-footer">
                    <div className="form-group">
                      <div className="col-md-12" style={{ marginTop: "30px" }}>
                        <div>
                          <input
                            type="submit"
                            value={"Speichern"}
                            className="btn btn-outline-warning col-md-6"
                          />
                          <input
                            type="button"
                            value={"Abbrechen"}
                            className="btn btn-outline-warning col-md-6"
                            onClick={backToAllProducts}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </ValidatorForm>
              )}
            </div>
          )}
        </div>
      </section>
    </React.Fragment>
  );
};
export default AdminUserEdit;
